export { default } from './AddressBook.vue';